import { render, staticRenderFns } from "./invoice-dialog.vue?vue&type=template&id=2cd23231&"
import script from "./invoice-dialog.vue?vue&type=script&lang=js&"
export * from "./invoice-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports